/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="62.7" height="39.7" viewBox="0 0 62.7 39.7" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <g fill="none" strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round">
          <circle cx="18.85" cy="19.15" r="4.5" stroke="#0e497b"/>
          <path stroke="#0e497b" d="M10.15 32.35v-.6a4.27 4.27 0 0 1 4.3-4.3h8.2"/>
          <circle cx="43.85" cy="19.15" r="4.5" stroke="#0e497b"/>
          <path stroke="#0e497b" d="M52.55 32.35v-.6a4.27 4.27 0 0 0-4.3-4.3h-8.2"/>
          <circle cx="31.35" cy="25.75" r="4.5" stroke="#ffb81c"/>
          <path stroke="#ffb81c" d="M22.65 39v-.6a4.31 4.31 0 0 1 4.2-4.3h8.8a4.31 4.31 0 0 1 4.3 4.2h0v.6"/>
          <circle cx="9.45" cy="8.05" r="4.5" stroke="#0e497b"/>
          <path stroke="#0e497b" d="M.75 21.15v-.6a4.27 4.27 0 0 1 4.3-4.3h4.4"/>
          <circle cx="53.25" cy="8.05" r="4.5" stroke="#0e497b"/>
          <path stroke="#0e497b" d="M62 21.15v-.6a4.27 4.27 0 0 0-4.3-4.3h-4.4"/>
          <circle cx="31.35" cy="5.25" r="4.5" stroke="#0e497b"/>
          <path stroke="#0e497b" d="M25.75 14.05h11.2"/>
        </g>
      </svg>
    );
  }
}

Icon.displayName = 'GroupOfSixPeopleIcon';

export default Icon;
